// 路由自动导入
// 利用webpack 的require.context自动导入
const req = require.context('./modules', false, /\.js$/)
let configRouter = []
req.keys().map((key) => {
	configRouter = configRouter.concat(req(key).default)
})
export default configRouter
